<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <!-- <div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
			</div> -->
      <div class="big_tit">
        {{ $t('sky.ying') }}
      </div>
      <div class="top_right" />
    </div>
		
    <div
      ref="videoScroll"
      class="tab-content"
      @scroll.passive="handleScroll"
    >
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <div
        v-if="!empty"
        class="box"
      >
        <div class="hot-recommend-div">
          <div
            v-if="list.length"
            class="list-item"
          >
            <div
              v-for="(item, index) in list"
              :key="item.id || index"
              class="movie-list-item"
            >
              <div
                class="cover_img van-image van-image--round"
                style="width: 100%; height: 170px;"
                @click="$router.push('/vplay/'+item.id)"
              >
                <img
                  :src="item.pic"
                  class="van-image__img"
                >
              </div>
              <div
                class="movie-list-item-bottom"
                style="bottom: 33px;"
                @click="$router.push('/vplay/'+item.id)"
              >
                <div class="movie-time-div">
                  <!-- <span>{{item.title}}</span> -->
                  <span style="font-size: 12px;">
                    {{ $t('sky.play') }}:{{ item.pnum }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="loading"
            class="list-loading"
          >
            {{ $t('pro2.loading') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "Vindex",
		data() {
			return {
				lang: this.$i18n.locale || "en_us",
				data: null,
				loading: false,
				page: 1,
				limit: 12,
				list: [],
				cur:0,
				type:0,
				islogin: false,
				finished: false,
				empty: false,
				requestLock: false,
			};
		},
		created() {
			this.$parent.footer("video",true);
		},
		mounted() {
			this.islogin = localStorage.getItem('token')!=null;
			if(!this.islogin){
				this.$router.push("/login");
				return;
			}
			this.loadVideos();
		},
		methods: {
			handleScroll(event) {
				var container = event.target;
				var distanceToBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
				if (distanceToBottom <= 100) {
					this.loadVideos();
				}
			},
			loadVideos() {
				if (this.requestLock || this.finished) {
					return;
				}
				this.requestLock = true;
				this.loading = true;
				Fetch("/index/videos",{
					type:this.cur,
                    page:this.page
                }).then((r) => {
					this.data = r.data;
					var rows = r.data && r.data.list ? r.data.list : [];
					if (rows.length > 0) {
						this.list = this.list.concat(rows);
						this.page++;
					}
					this.empty = this.list.length === 0;
					this.finished = !(r.data && r.data.has_more);
					this.loading = false;
					this.requestLock = false;
				}).catch(() => {
					this.loading = false;
					this.requestLock = false;
					this.finished = true;
				});
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		.language{
			position: absolute;
			top: 4px;
			left: 5px;
			height: 36px;
			img{
				height: 100%;
			}
		}
	}
.dlg-orderlist{
	width: 100%;
	height: 100%;
	background: #f5f5f5;

.main {
	overflow: hidden
}

.vux-x-icon {
fill: #fff
}

.ctn {
position: relative;
height: 100%
}

.weui-cells {
margin-top: 0
}

.vux-button-group {
padding: 10px
}

.vux-button-group>a {
height: 36px;
line-height: 36px
}

.vux-button-group>a.vux-button-group-current {
color: #fff
}

.tab-content {
position: relative;
overflow-y: auto;
// top: 50px;
// bottom: 0;
// left: 0;
// right: 0;
padding-bottom: 84px;
-webkit-overflow-scrolling: touch
}

.tab-content .weui-cell {
padding: 10px
}

.tab-content .vux-divider {
color: #999;
font-size: 14px;
padding: 10px
}

.tab-content .weui-form-preview__bd {
font-size: 14px
}

.weui-cell_access .weui-cell__ft {
width: 100%
}

.btTime {
text-align: left
}

.btTime .s_1 {
display: inline-block;
color: #999;
font-size: 13px;
margin-right: 1rem
}

.btTime .s_2 {
font-size: 16px;
color: #333
}

.btDate,.btTime .s_6 {
font-size: 12px;
color: #999
}

.btDate {
text-align: left
}

.btDate .s_3 {
display: inline-block;
margin-right: 1rem
}

.btDate .s_4 {
display: inline-block;
font-size: 13px;
color: #666;
padding-right: 5%;
max-width: 49%
}

.btDate .s_5 {
font-size: 12px
}

.isWin {
font-size: 14px;
color: #333
}

.lose {
color: green!important
}

.winFlag {
color: #ca2316!important
}

.vux-1px-r {
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis
}

@media screen and (max-device-width: 374px) {
	.btTime .s_2 {
		font-size:14px
	}

	.btDate .s_4,.btDate .s_5 {
		font-size: 12px
	}

	.isWin {
		font-size: 14px;
		margin-top: -10px
	}
}

	.h-ctb .ctb-bd dl, .h-ctb .ctb-hd {
		height: auto;
		padding: 10px 0;
		line-height: 18px;
		word-break: break-all
	}

	.h-ctb .ctb-hd dt {
		line-height: 18px
	}

	.h-ctb .ctb-bd {
		position: absolute;
		top: 40px;
		left: 0;
		right: 0;
		bottom: 30px;
		overflow-y: auto
	}
}
/deep/ .van-card__thumb{
	width: 68px;
	height: 68px;
}
/deep/ .van-card__content{
	min-height: 68px;
}
.basic_wrap {
	height: 100vh;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.tab-content {
	flex: 1;
	overflow-y: auto;
	padding-bottom: 84px;
	box-sizing: border-box;
	-webkit-overflow-scrolling: touch;
}
	.box{
		padding-bottom: 10vh;
	}
	
.hot-recommend-div {
	height: 100%;
	margin: 0px auto;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-wrap: wrap;
	width: 100%;
	.list-item {
	display: flex;
	width: calc(100% - 7px);
	margin: 10px auto;
	align-items: flex-start;
	justify-content: space-between;
	flex-wrap: wrap
	}
	
	.list-item .movie-list-item {
		width: calc(50% - 8px)
	}
	
	.movie-list-item .cover_img {
	border-radius: 10px;
	width: 45vw
	}
	
	.movie-list-item {
	margin-bottom: -15px
	}
	
	.list-item .movie-list-item-bottom {
	position: relative;
	width: 100%;
	bottom: 6vw
	}
	
	.list-item .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0,0,0,.4);
		height: 30px
	}
	
	.list-item .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between
	}
	
	.list-item .movie-list-item-bottom .movie-time-div .van-count-down {
	color: #fff
	}
	
	.list-item .movie-list-item .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 60%;
		padding-left: 8px;
		font-size: 12px
	}
	
	.list-item .movie-time-div {
		color: #fff;
		border-radius: 0 0 20px 20px;
		height: 5vw
	}
}
.list-loading {
	padding: 12px 0;
	color: #969799;
	font-size: 14px;
	text-align: center;
}
</style>
